<template>
  <v-container fill-height>
    <v-row align="center" justify="center" >
      <v-col cols="2">
          <v-img  src="../../public/static/logo_ultraip.png"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "LoadingScreen",
  props: ["isLoading"],
  mounted(){
    if(this.$store.state.isAuthenticated)
      this.$router.push('/monitor')/**/
  }
};
</script>

<style>
.logo {
  height: 100%;
}
.loader {
  bottom: 0;
  color: white;
  display: block;
  font-size: 32px;
  left: 0;
  overflow: hidden;
  padding-top: 10vh;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
}

.fadeout {
  animation: fadeout 2s forwards;
}

@keyframes fadeout {
  to {
    opacity: 0;
    visibility: hidden;
  }
}
</style>